import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { BOOK_CONDITION, productNeedsConditionChoice } from 'utils/bookCondition';

const nsDetalle = 'detalle';
const nsCart = 'cart';

const BookConditionChoiceModal = ({ show, product, onHide, onConfirm, confirmLabel, confirmDisabled }) => {
  const { t } = useTranslation([nsDetalle, nsCart]);
  const [selected, setSelected] = useState(BOOK_CONDITION.NEW);

  useEffect(() => {
    if (!product || !productNeedsConditionChoice(product)) return;
    const opts = [];
    if (product.has_stock) opts.push(BOOK_CONDITION.NEW);
    if (product.has_used) opts.push(BOOK_CONDITION.USED);
    if (product.has_newbalance) opts.push(BOOK_CONDITION.NEWBALANCE);
    const current = product.book_condition;
    if (current && opts.includes(current)) {
      setSelected(current);
    } else {
      setSelected(opts[0] || BOOK_CONDITION.NEW);
    }
  }, [product]);

  if (!product) return null;

  const options = [];
  if (product.has_stock) {
    options.push({
      value: BOOK_CONDITION.NEW,
      label: t('bookConditionNew', { ns: nsDetalle }),
    });
  }
  if (product.has_used) {
    options.push({
      value: BOOK_CONDITION.USED,
      label: t('bookConditionUsed', { ns: nsDetalle }),
    });
  }
  if (product.has_newbalance) {
    options.push({
      value: BOOK_CONDITION.NEWBALANCE,
      label: t('bookConditionLikeNew', { ns: nsDetalle }),
    });
  }

  const handleConfirm = () => {
    onConfirm(selected);
  };

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{t('chooseBookConditionTitle', { ns: nsDetalle })}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3 text-muted small">{t('chooseBookConditionHint', { ns: nsDetalle })}</p>
        <div className="book-condition-choice-options">
          {options.map((opt) => (
            <div key={opt.value} className="form-check mb-2">
              <input
                type="radio"
                className="form-check-input"
                name="book_condition_choice"
                id={`book-cond-${opt.value}`}
                checked={selected === opt.value}
                onChange={() => setSelected(opt.value)}
              />
              <label className="form-check-label text-body" htmlFor={`book-cond-${opt.value}`}>
                {opt.label}
              </label>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0">
        <Button variant="outline-secondary" onClick={onHide}>
          {t('cancelChoice', { ns: nsCart })}
        </Button>
        <Button variant="primary" onClick={handleConfirm} disabled={options.length === 0 || confirmDisabled}>
          {confirmLabel || t('confirmAddToCart', { ns: nsDetalle })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BookConditionChoiceModal;
